import React, { useState, useEffect } from "react";
import '../styles/Test.css';

function Test() {

  return (
    <div>Hola</div>
  );
};

export default Test;
